import { AAGUID } from '@interticket/core';
import { ICustomer } from '@core/interfaces/customer/customer.interface';
import { CustomerType } from '@core/enums/customer/customer-type.enum';

export class Customer implements ICustomer {

  readonly id?: AAGUID;
  readonly type: CustomerType;
  readonly firstName?: string;
  readonly lastName?: string;
  readonly email: string;
  readonly phoneNumber?: string;
  readonly zipCode: string;
  readonly city: string;
  readonly country: string;
  readonly address: string;
  readonly billingName: string;
  readonly billingTaxNumber: string;
  readonly billingZipCode: string;
  readonly billingCity: string;
  readonly billingAddress: string;
  readonly billingCountry: string;
  readonly billingCounty: string;
  readonly companyName?: string;
  readonly vatNumber?: string;
  readonly county?: string;

  constructor(iCustomer: ICustomer) {
    this.id = iCustomer.id;
    this.type = iCustomer.type;
    this.firstName = iCustomer.firstName;
    this.lastName = iCustomer.lastName;
    this.email = iCustomer.email;
    this.phoneNumber = iCustomer.phoneNumber;
    this.zipCode = iCustomer.zipCode;
    this.city = iCustomer.city;
    this.country = iCustomer.country;
    this.address = iCustomer.address;
    this.billingName = iCustomer.billingName;
    this.billingTaxNumber = iCustomer.billingTaxNumber;
    this.billingZipCode = iCustomer.billingZipCode;
    this.billingCity = iCustomer.billingCity;
    this.billingAddress = iCustomer.billingAddress;
    this.billingCountry = iCustomer.billingCountry;
    this.companyName = iCustomer.companyName;
    this.county = iCustomer.county;
    this.vatNumber = iCustomer.vatNumber;
    this.billingCounty = iCustomer.billingCounty;
  }

}
